import "./off_screen.scss"

